export default ".color-patch {\n  float: left;\n  width: 100%;\n  border: 1px solid black;\n  text-align: center;\n}";